import React from 'react';
import { useAuth } from './context/AuthProvider';
import { Routes, Route, Navigate, Router } from 'react-router-dom';
import Cookies from 'js-cookie';

// COMPONENTES PARA RUTAS
import MainSideBar from './components/plantilla/sidebar/MainSideBar';
import Login from './pages/login/Login';
import Dashboard from './pages/dashboard/Dashboard';
import DashboardAlertas from './pages/monitoreo/alertas/DashboardAlertas';

// CATALOGOS
import Usuarios from './pages/catalogos/usuarios/Usuarios';
import Perfiles from './pages/catalogos/perfiles/Perfiles';
import Tractores from './pages/catalogos/tractores/Tractores';
import Cajas from './pages/catalogos/cajas/Cajas';
import Operadores from './pages/catalogos/operadores/Operadores';
import IncidenciasMonitoreo from './pages/monitoreo/incidencias/IncidenciasMonitoreo';
import FuelOpView from './pages/Diesel/fuelUp/FuelOpView';
import DashboardDiesel from './pages/Diesel/dashboard/DashboardDiesel'; 
import Formularios from './pages/inspecciones/catalogos/Formularios';
import Tolls from './pages/catalogos/tolls/Tolls';

// FUEL REPORT
import MasterInd from './pages/master_indicator/Master';
import Despacho from './pages/Diesel/despachos/Despacho';

// TELEMATICA CLIENTES
import Telemetria from './pages/telematica/unidadesActivas/Telemetria';
import FuelGeneralView from './pages/Diesel/fuelUp/FuelGeneralView';
import MenuOperadores from './pages/catalogos/menuOperadores/MenuOperadores';

//Cargas Fuel Up V2
import AgregarColombia from './pages/fuel_report/AgregarCarga';

const Main = () => {

    const { isLoggedIn } = useAuth();
    const perfil = Cookies.get('ebt_perfil');
    const esDespachador = perfil === '22';
    
    return (

        <div className="App">

            <div 
                style={{ 
                    backgroundColor: '#f2f4f4', 
                    width: '100vw', 
                    height: '100vh',  
                    display: 'flex',
                }}
            >

                {/* VALIDAMOS SI ESTA LOGUEADO PARA MOSTRAR EL SIDEBAR */}

                {
                    (isLoggedIn && !esDespachador && <MainSideBar />)
                }

                <div 
                    style={{ 
                        flex: 1, 
                        padding: isLoggedIn ? '20px' : '0px',
                        marginTop: isLoggedIn ? 40 : '0px',
                        overflow: 'auto'
                    }}
                >

                    {/* RUTEO PARA PAGINAS */}

                    <Routes>

                        {/* VALIDAR LOGIN */}
                        <Route
                            path="/"
                            element={
                                isLoggedIn
                                    ? (
                                        <Navigate
                                            to={
                                                esDespachador
                                                    ? "/diesel/fuel_up/v2/agregar"
                                                    : "/dashboard"
                                            }
                                            replace
                                        />
                                    )
                                    : <Login />
                            }
                        />
                        {/* DASHBOARD */}
                        <Route
                            path="/dashboard"
                            element={
                                !isLoggedIn
                                    ? <Navigate to="/" replace />
                                    : esDespachador
                                        ? <Navigate to="/diesel/fuel_up/v2/agregar" replace />
                                        : <Dashboard />
                            }
                        />
                        
                        <Route 
                            path='/inspecciones' 
                            element={isLoggedIn ? <Formularios /> : <Navigate to="/"/> }
                        />

                        {/* ----------------------------------------------------------- */}

                        {/* USUARIOS */}
                        <Route 
                            path='/usuarios' 
                            element={isLoggedIn ? <Usuarios/> : <Navigate to="/"/> }
                        />

                        {/* PERFILES */}
                        <Route 
                            path='/perfiles' 
                            element={isLoggedIn ? <Perfiles/> : <Navigate to="/"/> }
                        />

                        {/* TRACTORES */}
                        <Route 
                            path='/tractores' 
                            element={isLoggedIn ? <Tractores/> : <Navigate to="/"/> }
                        />

                        {/* CAJAS */}
                        <Route 
                            path='/cajas' 
                            element={isLoggedIn ? <Cajas/> : <Navigate to="/"/> }
                        />

                        {/* OPERADORES */}
                        <Route 
                            path='/operadores' 
                            element={isLoggedIn ? <Operadores/> : <Navigate to="/"/> }
                        />

                        <Route
                            path='/menuOperadores'
                            element={isLoggedIn ? <MenuOperadores/> : <Navigate to="/"/> }
                        />

                        {/* TOLLS */}
                        <Route 
                            path='/tolls' 
                            element={isLoggedIn ? <Tolls/> : <Navigate to="/" />}
                        />


                        {/* ----------------------------------------------------------- */}

                        {/* TELEMATICA CLIENTES */}

                        <Route
                            path='/telematica' 
                            element={isLoggedIn ? <Telemetria /> : <Navigate to="/"/> }
                        />

                        {/* ----------------------------------------------------------- */}

                        {/* DIESEL */}

                        {/* <Route
                            path='/diesel/dashboard'
                            element={isLoggedIn ? <DashboardDiesel /> : <Navigate to="/" />}
                        /> */}

                        {/* <Route
                            path='/diesel/fuelup'
                            element={isLoggedIn ? <FuelOpView /> : <Navigate to="/" />}
                        /> */}
                        
                        {/* <Route
                            path='/diesel/despacho'
                            element={isLoggedIn ? <Despacho /> : <Navigate to="/" />}
                        /> */}
                        

                        {/* MASTER */}
                        <Route 
                            path='/master_indicator' 
                            element={isLoggedIn ? <MasterInd/> : <Navigate to="/"/> }
                        />

                        {/* <Route 
                            path='/diesel/master_dashboard' 
                            element={isLoggedIn ? <Master_Dashboard/> : <Navigate to="/"/> }
                        /> */}

                        {/* BITACORA FUEL */}
                        {/* <Route 
                            path='/diesel/fuelgeneralView' 
                            element={<FuelGeneralView/> }
                        /> */}

                        {/* ----------------------------------------------------------- */}
                        {/* INSPECCIONES Y FORMULARIOS */}
                        {/* ----------------------------------------------------------- */}
                        <Route
                            path='/inspeccion/formularios'
                            element={isLoggedIn ? <Formularios/> : <Navigate to="/" />}
                        />
                        {/* ----------------------------------------------------------- */}
                        {/* Agregar Carga Fuel Up V2 */}
                        <Route 
                            path='/diesel/fuel_up/v2/agregar' 
                            element={isLoggedIn ? <AgregarColombia/> : <Navigate to="/" />}
                        />                        

                    </Routes>

                </div>

            </div>

        </div>

    )

}

export default Main